import * as Swiper from "../libs/swiper";

export function differencesSlider() {
    const $window = this.$window;
    $window.on("load", function () {
        if ($window.outerWidth() < 1024) {
            const slider = $(".differences .slider");

            const sliderSettings = {
                slidesPerView: 1,
                autoHeight: true,
                loop: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            };

            const mySwiper = new Swiper(slider, sliderSettings);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/differences-slider.js